import React from 'react';
import { Heading, Paragraph, Tag, Box } from 'components';
import { InfoTooltipStyled } from './infoTooltip.styled';

interface InfoTooltipProps {
  title?: string;
  description?: string;
  tags?: string[];
}

const InfoTooltip = ({ title, description, tags }: InfoTooltipProps) => {
  return (
   <InfoTooltipStyled>
      {title ? (
        <Heading size='xsmall' variant='tertiary'>
          {title}
        </Heading>
      ) : null}
      <Paragraph variant='secondary' margin='0.5rem 0' size='xsmall'>
        {description}
      </Paragraph>
      {tags &&
        tags.map(tag => (
          <Box key={tag} m={1} sx={{ display: 'inline-flex' }}>
            <Tag>{tag}</Tag>
          </Box>
        ))}
    </InfoTooltipStyled>
  );
};

export default InfoTooltip;
